import { getAPIFromDomain } from "lib/api";
import { FreightcomCredential } from "pages/_common/organization/OrganizationDetailsPage/FreightcomCredentialsTable";

export const fetchFreightcomCredentials = async (organization_id: string): Promise<FreightcomCredential[]> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.get(`/organizations_freightcom/${organization_id}`);
  return res.data;
};

export const insertFreightcomCredentials = async (body: FreightcomCredential): Promise<FreightcomCredential> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.post(`/organizations_freightcom`, body);
  return res.data;
};

export const updateFreightcomCredentials = async (body: FreightcomCredential): Promise<FreightcomCredential> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.put(`/organizations_freightcom/${body.id}`, body);
  return res.data;
};

export const deleteFreightcomCredentials = async (id: string): Promise<FreightcomCredential> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.delete(`/organizations_freightcom/${id}`);
  return res.data;
};
